import React from 'react'
import styles from "../css/SkeletonNote.module.css"

const SkeletonNote = () => {
  return (
    <div className={styles.noteCard}>
        <div className={styles.noteCardBar}></div>
        <div className={styles.noteCardBody}>
            <div className={styles.noteCardTitle}></div>
            <div className={styles.noteCardPreview}>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div className={styles.noteCardTags}>
                <span></span>
                <span></span>
            </div>
        </div>
        <div className={styles.noteCardFooter}>
            <span className={styles.noteCardTime}></span>
        </div>
    </div>
  )
}

export default SkeletonNote